module.exports = __webpack_public_path__ + "media/images/pdf/header-5b8e0a0dddbd63f93ac0ff4db2edc47a.png";